import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ColumnChooser from '../../../../components/ColumnChooser';
import ExcelExportMenu from '../../../../components/ExcelExportMenu';
import { ExcelExportMode } from '../../../../helpers/excelExportRequest';
import { ColumnChooserModel } from '../../../../models/common/ColumnChooserModel';
import { GetDeviceDataSchemeListPagingAndFilterRequest } from '../../../../models/request/deviceDataScheme/GetDeviceDataSchemeListPagingAndFilterRequest';
import { RootState } from '../../../../redux/store';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';
import TableConstantActions from '../../../../components/TableConstantActions';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    excelExport: (mode: ExcelExportMode) => void
    filter: GetDeviceDataSchemeListPagingAndFilterRequest
    getData: (_filter?: GetDeviceDataSchemeListPagingAndFilterRequest | undefined) => Promise<void>
    setFilter: React.Dispatch<React.SetStateAction<GetDeviceDataSchemeListPagingAndFilterRequest>>
    selectedCount: number
    deleteFunction: () => void
    updateFunction: () => void
    onSearchSubmit: (e: any) => void
}

const DeviceDataSchemeListFilters = ({
    columns,
    setColumns,
    getColumns,
    pageName,
    pageVersion,
    excelExport,
    filter,
    getData,
    setFilter,
    selectedCount,
    deleteFunction,
    updateFunction,
    onSearchSubmit
}: Props) => {
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth)

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    return (
        <React.Fragment>
            {/* Arama kutusu ve Güncelle / Sil düğmeleri üst şeritte (standart). */}
            <TableConstantActions
                deleteFunction={deleteFunction}
                onSearchSubmit={onSearchSubmit}
                pageName={pageName}
                hideSearch={true}
                searchTerm={filter.searchTerm}
                selectedCount={selectedCount}
                setSearchTerm={(e) => setFilter({ ...filter, searchTerm: e })}
                updateFunction={updateFunction}
            />

            <ColumnChooser
                columns={columns}
                getColumns={getColumns}
                pageName={pageName}
                pageVersion={pageVersion}
                setColumns={setColumns}
            />

            <ExcelExportMenu
                pageName={pageName}
                selectedCount={selectedCount}
                onExport={excelExport}
            />

            {/* <Filters
                filter={filter}
                getData={getData}
                onReset={() => getData({ ...filter, selectedCurrencyTypes: [], currentPage: 1, skip: 0 })}
            >
                <div className='mb-5'>
                    <label className='form-label fw-bold'>Döviz Cinsi:</label>

                    <div>
                        <CustomMultiSelect
                            onChange={(e) => setFilter({
                                ...filter,
                                selectedCurrencyTypes: e
                            })}
                            selectedValues={filter.selectedCurrencyTypes}
                            onMenuOpen={() => ConstantService.getConstantList('CURRENCY', undefined, undefined)}
                            labelName='additionalValue1'
                            valueName='constantId'

                        />
                    </div>
                </div>
            </Filters> */}

            <React.Fragment>
                {
                    auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canInsert && (
                        <div className='m-0'>
                            <a
                                onClick={() => navigate('/datasetting/listadd')}
                                className='btn btn-sm fw-bold btn-primary'
                            >
                                Yeni Veri Ayarı Ekle
                            </a>
                        </div>
                    )
                }
            </React.Fragment>
        </React.Fragment>
    )
}

export default DeviceDataSchemeListFilters;